import {faGlobe} from "@fortawesome/free-solid-svg-icons";

export default faGlobe;
